import { TabsProps } from '@chakra-ui/react';
import React, { useCallback, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Tabs from 'components/Tabs';
import Page404 from 'containers/Page404';
import { useParamsQuery } from 'hooks/common/useParamsQuery';

export interface IRouteTabsProps extends TabsProps {
  tabHeaders: Array<any>;
}

const RouteTabs: React.FC<IRouteTabsProps> = ({ children, tabHeaders }) => {
  const navigate = useNavigate();
  const searchQuery = useParamsQuery();
  const activeTab = searchQuery.get('tab');

  useEffect(() => {
    if (!activeTab) {
      navigate('?tab=' + tabHeaders[0].tabName, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const activeTabIndex = useMemo(
    () => tabHeaders.findIndex((item: any) => item.tabName === activeTab),
    [activeTab, tabHeaders]
  );

  const handleTabChange = useCallback((index: number) => {
    navigate('?tab=' + tabHeaders[index].tabName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (activeTab !== null && activeTabIndex === -1) return <Page404 />;

  return (
    <Tabs onChange={handleTabChange} index={activeTabIndex}>
      {children}
    </Tabs>
  );
};

export default RouteTabs;
